import axios from "axios";


// LOCAL
// const todosModulos = async (state, setCarga) => {
//     setCarga(true);
//     const peticion = await axios
//     .get('http://localhost:3000//turnera/apiTurnera/index.php/api/modulos');
//     state(peticion.data);
    
//     setCarga(false);
//     return peticion.data;
// }

// const delegacionesPorModulo = async (state, modulo, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`http://localhost:3000//turnera/apiTurnera/index.php/api/dependencias/${modulo}`);
//     state(peticion.data);
//     setCarga(false);
//     return peticion.data;
// }

// const serviciosPorDelegacion = async (state, delegacion, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`http://localhost:3000//turnera/apiTurnera/index.php/api/servicios/${delegacion}`);
//     state(peticion.data);
//     setCarga(false);

//     return peticion.data;
// }

// const stringADate = (string) =>{
//     const dateAux = new Date(string + "T00:00:00");
//     return {year: dateAux.getFullYear(), month: dateAux.getMonth() + 1 , day: dateAux.getDate()}
// }

// const diasPorServicio = async (servicio, mes, anio, setCarga) => {
//     setCarga(true);
//     let fechasAux =[];
//     const peticion = await axios.get(`http://localhost:3000//turnera/apiTurnera/index.php/api/servicios/${servicio}/${mes}/${anio}`);
//     if (!peticion.data.status) {
//         peticion.data.
//             filter(fecha => fecha.cantidad > 0).
//             map(pet => fechasAux.push(stringADate(pet.diaCompleto)));
//     }
//     else {
//         setCarga(false);
//         return "error";
//     }

//     setCarga(false);
//     return (fechasAux);
// }

// const addDays = (startDate) => {
//     const date = new Date(startDate.year, (startDate.month - 1), 0);
//     let datesCollection = []
    
//     for (var i = 1; i < 365; i++) {
//         const newDate = new Date(date.getTime() + i * 1000 * 60 * 60 * 24);
//         datesCollection.push({year: newDate.getFullYear(), month: newDate.getMonth() + 1 , day: newDate.getDate()});
//     }
    
//     return datesCollection;
// }

// const horasPorDia = async (state, servicio, dia, mes, anio, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`http://localhost:3000//turnera/apiTurnera/index.php/api/servicios/${servicio}/${dia}/${mes}/${anio}`);

//     await state(peticion.data);
//     setCarga(false);
//     return peticion.data;
// }

// const DNIestaRegistrado = async (DNI, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`http://prd-mod-web07.vicentelopez.gov.ar:3000/users/single/${DNI}`);
//     setCarga(false);
//     return peticion.data;
// }





// DEV SERVER
// const todosModulos = async (state, setCarga) => {
//     setCarga(true);
//     const peticion = await axios
//     .get('http://10.100.18.213/turnera/apiTurnera/index.php/api/modulos');
//     state(peticion.data);
    
//     setCarga(false);
//     return peticion.data;
// }

// const delegacionesPorModulo = async (state, modulo, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`http://10.100.18.213/turnera/apiTurnera/index.php/api/dependencias/${modulo}`);
//     state(peticion.data);
//     console.log(peticion.data)
//     setCarga(false);
//     return peticion.data;
// }

// const serviciosPorDelegacion = async (state, delegacion, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`http://10.100.18.213/turnera/apiTurnera/index.php/api/servicios/${delegacion}`);
//     state(peticion.data);
//     setCarga(false);

//     return peticion.data;
// }

// const stringADate = (string) =>{
//     const dateAux = new Date(string + "T00:00:00");
//     return {year: dateAux.getFullYear(), month: dateAux.getMonth() + 1 , day: dateAux.getDate()}
// }

// const diasPorServicio = async (servicio, mes, anio, setCarga) => {
//     setCarga(true);
//     let fechasAux =[];
//     const peticion = await axios.get(`http://10.100.18.213/turnera/apiTurnera/index.php/api/servicios/${servicio}/${mes}/${anio}`);
//     if (!peticion.data.status) {
//         peticion.data.
//             filter(fecha => fecha.cantidad > 0).
//             map(pet => fechasAux.push(stringADate(pet.diaCompleto)));
//     }
//     else {
//         setCarga(false);
//         return "error";
//     }

//     setCarga(false);
//     return (fechasAux);
// }

// const addDays = (startDate) => {
//     const date = new Date(startDate.year, (startDate.month - 1), 0);
//     let datesCollection = []
    
//     for (var i = 1; i < 365; i++) {
//         const newDate = new Date(date.getTime() + i * 1000 * 60 * 60 * 24);
//         datesCollection.push({year: newDate.getFullYear(), month: newDate.getMonth() + 1 , day: newDate.getDate()});
//     }
    
//     return datesCollection;
// }

// const horasPorDia = async (state, servicio, dia, mes, anio, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`http://10.100.18.213/turnera/apiTurnera/index.php/api/servicios/${servicio}/${dia}/${mes}/${anio}`);

//     await state(peticion.data);
//     setCarga(false);
//     return peticion.data;
// }

// const DNIestaRegistrado = async (DNI, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`http://prd-mod-web07.vicentelopez.gov.ar:3000/users/single/${DNI}`);
//     setCarga(false);
//     return peticion.data;
// }





// PROD
const todosModulos = async (state, setCarga) => {
    setCarga(true);
    const peticion = await axios
    .get('https://api-turnera.vicentelopez.gov.ar/api/modulos');
    state(peticion.data);
    
    setCarga(false);
    return peticion.data;
}

const delegacionesPorModulo = async (state, modulo, setCarga) => {
    setCarga(true);
    const peticion = await axios.get(`https://api-turnera.vicentelopez.gov.ar/api/dependencias/${modulo}`);
    state(peticion.data);
    console.log(peticion.data)
    setCarga(false);
    return peticion.data;
}

const serviciosPorDelegacion = async (state, delegacion, setCarga) => {
    setCarga(true);
    const peticion = await axios.get(`https://api-turnera.vicentelopez.gov.ar/api/servicios/${delegacion}`);
    state(peticion.data);
    setCarga(false);

    return peticion.data;
}

const stringADate = (string) =>{
    const dateAux = new Date(string + "T00:00:00");
    return {year: dateAux.getFullYear(), month: dateAux.getMonth() + 1 , day: dateAux.getDate()}
}

const diasPorServicio = async (servicio, mes, anio, setCarga) => {
    setCarga(true);
    let fechasAux =[];
    const peticion = await axios.get(`https://api-turnera.vicentelopez.gov.ar/api/servicios/${servicio}/${mes}/${anio}`);
    if (!peticion.data.status) {
        peticion.data.
            filter(fecha => fecha.cantidad > 0).
            map(pet => fechasAux.push(stringADate(pet.diaCompleto)));
    }
    else {
        setCarga(false);
        return "error";
    }

    setCarga(false);
    return (fechasAux);
}

const addDays = (startDate) => {
    const date = new Date(startDate.year, (startDate.month - 1), 0);
    let datesCollection = []
    
    for (var i = 1; i < 365; i++) {
        const newDate = new Date(date.getTime() + i * 1000 * 60 * 60 * 24);
        datesCollection.push({year: newDate.getFullYear(), month: newDate.getMonth() + 1 , day: newDate.getDate()});
    }
    
    return datesCollection;
}

const horasPorDia = async (state, servicio, dia, mes, anio, setCarga) => {
    setCarga(true);
    const peticion = await axios.get(`https://api-turnera.vicentelopez.gov.ar/api/servicios/${servicio}/${dia}/${mes}/${anio}`);

    await state(peticion.data);
    setCarga(false);
    return peticion.data;
}

const DNIestaRegistrado = async (DNI, setCarga) => {
    setCarga(true);
    const peticion = await axios.get(`http://prd-mod-web07.vicentelopez.gov.ar:3000/users/single/${DNI}`);
    setCarga(false);
    return peticion.data;
}




// PROD X
// const todosModulos = async (state, setCarga) => {
//     setCarga(true);
//     const peticion = await axios
//     .get('https://api-turnera.vicentelopez.gov.ar/api/modulos');
//     state(peticion.data);
    
//     setCarga(false);
//     return peticion.data;
// }

// const delegacionesPorModulo = async (state, modulo, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`https://api-turnera.vicentelopez.gov.ar/api/dependencias/${modulo}`);
//     state(peticion.data);
//     setCarga(false);
//     return peticion.data;
// }

// const serviciosPorDelegacion = async (state, delegacion, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`https://api-turnera.vicentelopez.gov.ar/api/servicios/${delegacion}`);
//     state(peticion.data);
//     setCarga(false);

//     return peticion.data;
// }

// const stringADate = (string) =>{
//     const dateAux = new Date(string + "T00:00:00");
//     return {year: dateAux.getFullYear(), month: dateAux.getMonth() + 1 , day: dateAux.getDate()}
// }

// const diasPorServicio = async (servicio, mes, anio) => {
//     let fechasAux =[];
//     const peticion = await axios.get(`https://api-turnera.vicentelopez.gov.ar/api/servicios/${servicio}/${mes}/${anio}`);
//     peticion.data.
//         filter(fecha => fecha.cantidad > 0).
//         map(pet => fechasAux.push(stringADate(pet.diaCompleto)));

//     return (fechasAux);
// }

// const addDays = (startDate) => {
//     const date = new Date(startDate.year, (startDate.month - 1), 0);
//     let datesCollection = []
    
//     for (var i = 1; i < 365; i++) {
//         const newDate = new Date(date.getTime() + i * 1000 * 60 * 60 * 24);
//         datesCollection.push({year: newDate.getFullYear(), month: newDate.getMonth() + 1 , day: newDate.getDate()});
//     }
    
//     return datesCollection;
// }

// const horasPorDia = async (state, servicio, dia, mes, anio, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`https://api-turnera.vicentelopez.gov.ar/api/servicios/${servicio}/${dia}/${mes}/${anio}`);

//     await state(peticion.data);
//     setCarga(false);
// }

// const DNIestaRegistrado = async (DNI, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`http://prd-mod-web07.vicentelopez.gov.ar:3000/users/single/${DNI}`);
//     setCarga(false);
//     return peticion.data;
// }


export {
    todosModulos,
    delegacionesPorModulo,
    serviciosPorDelegacion,
    diasPorServicio,
    horasPorDia,
    addDays,
    DNIestaRegistrado,
}